import React, { useEffect, useState } from "react";
import { getAuthToken } from "../../../util/auth";
import { getApiChara } from "../../../util/getApi";
import { useNavigate } from "react-router-dom";
import UserList from './UserList';
import Loader from '../../UI/Loader';
import { FaUserFriends, FaSearch, FaUserPlus, FaCalendarAlt } from 'react-icons/fa';
import classes from './UserList.module.css';
import { useTranslation } from "react-i18next";

const Users = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchName, setSearchName] = useState('');
  const [userData, setUserData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const OnSearchNameHandler = (sname) => {
    setSearchName(sname.toLowerCase());
  };

  useEffect(() => {
    const fetchData = async () => {
      const token = getAuthToken();
      if (token === null || token === 'EXPIRED') {
        navigate('/');
      }
      setIsLoading(true);
      try {
        const apiChar = getApiChara();
        const apiUrl = `${apiChar}/users/getAllUsers`;

        const response = await fetch(apiUrl, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (!response.ok) {
          throw new Error("Could not fetch users");
        }

        const data = await response.json();
        setUserData(data);
      } catch (error) {
        console.error("Error fetching user data:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [navigate]);

  const newUserHandler = () => {
    navigate('signup');
  };

  const currentDate = new Date();
  const formattedDate = `${currentDate.getDate()}-${currentDate.getMonth() + 1}-${currentDate.getFullYear()}`;

  return (
    <>
      {isLoading && <Loader />}
      <div className="container">
        <div className="d-flex justify-content-between align-items-center mb-4 mt-2">
          <h4 style={{ color: 'var(--primary-color)', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '1px', margin: 0 }}>
            {t("User Information")}
          </h4>
          <span className="badge bg-light text-dark border p-2" style={{ fontSize: '0.85rem' }}>
            <FaCalendarAlt className="me-1" style={{ color: 'var(--primary-color)' }} /> {formattedDate}
          </span>
        </div>

        <div className="row g-2 align-items-center mb-4 px-2">
          <div className="col-7 col-md-6">
            <div className="input-group">
              <span className="input-group-text bg-white border-end-0">
                <FaSearch className="text-muted" />
              </span>
              <input
                type="text"
                className="form-control border-start-0 ps-0"
                placeholder={t("Search User by Name...")}
                value={searchName}
                onChange={(e) => OnSearchNameHandler(e.target.value)}
                style={{ boxShadow: 'none' }}
              />
            </div>
          </div>
          <div className="col-5 col-md-6 d-flex justify-content-end gap-2">
            <button
              className={classes.premiumBtn}
              onClick={newUserHandler}
            >
              <FaUserPlus className="me-2" /> {t("New User")}
            </button>
          </div>
        </div>
      </div>
      <UserList userData={userData} searchPara={searchName} />
    </>
  );
};

export default Users;
